// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'bank-statement.page.title': 'Statements',
    'bank-statement.page.create.title': 'New Statement',

    'bank-statement.button.create': 'Create Statement',
    'bank-statement.button.select': 'Select',
    'bank-statement.button.search': 'Apply',
    'bank-statement.button.rollback_statement': 'Rollback Statement',
    'bank-statement.button.auto_reconciliation': 'Auto Reconciliation',

    'bank-statement.label.opening_balance': 'Opening Balance',
    'bank-statement.label.closing_balance': 'Closing Balance',
    'bank-statement.label.statement_balance': 'Statement Balance',
    'bank-statement.label.book_balance': 'Books Balance',
    'bank-statement.label.difference': 'Difference',
    'bank-statement.label.statement_amount': 'Amount',
    'bank-statement.label.account_name': 'Bank Account',
    'bank-statement.label.reconciled': 'Reconciled',
    'bank-statement.label.unreconciled': 'Not Reconciled',

    'bank-statement.success.message.bank_statement_created': 'Your bank statement has been created',
    'bank-statement.success.message.bank_statement_updated': 'Your bank statement has been updated',
    'bank-statement.success.message.statement_reverted': 'Bank statement has been rolled back successfully.',

    'bank-statement.modal.title.rollback_statement': 'Rollback Statement',
    'bank-statement.modal.message.rollback_statement': 'Are you sure you want to rollback this statement? This will revert all reconciled transactions back to "Not Reconciled" status.',
};
